import { Box, Grid, Typography } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";

export default function HumanResources() {
    return <>
        <Box>
            <BAScreenHeader title='Human Resources' />
            <Box>
                <Grid spacing={2} container>
                    <Grid item md={3}>
                        <Box className="bg-white p-3 rounded shadow">
                            <Typography variant="h5">Pay Roll</Typography>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Box className="bg-white p-3 rounded shadow">
                            <Typography variant="h5">Attendance</Typography>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Box className="bg-white p-3 rounded shadow">
                            <Typography variant="h5">Employee</Typography>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Box className="bg-white p-3 rounded shadow">
                            <Typography variant="h5">Leaves</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    </>
}